/**
 * useProjects — fetches `/api/projects` for the authenticated tenant.
 *
 * The home page (`src/routes/index.tsx`) uses this to decide whether to
 * redirect into the first project's board or render the empty state.
 * Phase 2a only needs the list shape; the detail/CRUD hooks land in 2b.
 */

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/api/client'
import type { Project } from '@/api/types-bridge'

export const PROJECTS_QUERY_KEY = ['projects'] as const

export function useProjects() {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEY,
    queryFn: async () => {
      // BE wraps every response in `{ data: ... }` (Phase 2b Pass 1).
      // The list endpoint now returns `{ data: Project[] }` (previously
      // `{ projects: Project[] }`); consumers still see `Project[]`.
      const res = await apiClient<{ data: Project[] }>('/api/projects')
      return res.data
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
